import { z } from 'zod'

import {
  AiBusinessKnowledgeSchemas,
  KnowledgeEntryState,
  KnowledgeErrorCode,
} from 'shared/api/requests/aiBusinessKnowledge/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const KnowledgeSocketEventsSchemas = {
  entryCreated: SocketEventBaseSchema.extend({
    event: z.literal('ai_business_knowledge_entry_created'),
    data: AiBusinessKnowledgeSchemas.entry,
  }),

  entryUpdated: SocketEventBaseSchema.extend({
    event: z.literal('ai_business_knowledge_entry_updated'),
    data: AiBusinessKnowledgeSchemas.entry,
  }),

  entryDeleted: SocketEventBaseSchema.extend({
    event: z.literal('ai_business_knowledge_entry_deleted'),
    data: z.object({
      id: z.string(),
    }),
  }),

  entryStateUpdated: SocketEventBaseSchema.extend({
    event: z.literal('ai_business_knowledge_entry_state_updated'),
    data: z.object({
      id: z.string(),
      state: z.enum(KnowledgeEntryState),
      error_code: z.enum(KnowledgeErrorCode).optional(),
    }),
  }),
}
